import ScrollHint from 'scroll-hint'
import 'scroll-hint/css/scroll-hint.css';

new ScrollHint('.js-scrollable');
